import {useState} from 'react';

import {serverAPI} from 'features/server/api/serverAPI';
import {
    buildServerAgentCommand,
    isServerAgentConnected,
    ServerAgentScriptVariant,
} from 'features/server/lib/serverView';
import {runtimeEnv} from 'shared/lib/runtimeEnv';

const STATUS_POLLING_INTERVAL = 30000;

interface IParams {
    token: string,
    serverUuid: string,
    variant: ServerAgentScriptVariant,
}

export const useServerAgentConnection = ({token, serverUuid, variant}: IParams) => {
    const [screenOpenedAt] = useState(() => Date.now());

    const {data: statusData} = serverAPI.useGetServerStatusQuery(serverUuid, {
        pollingInterval: STATUS_POLLING_INTERVAL,
    });

    const isConnected = isServerAgentConnected(statusData?.status, statusData?.last_seen_at, screenOpenedAt);
    const command = buildServerAgentCommand({
        variant,
        token,
        repoOwner: runtimeEnv('REACT_APP_GITHUB_REPO_OWNER'),
        baseHost: runtimeEnv('REACT_APP_BASE_HOST'),
    });

    return {command, isConnected};
};
